import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import FaCheck from "../../../assets/icons/check";
import RiSortAsc from "../../../assets/icons/sortAsc";
import { defaultPage } from "../../../utils/constants";

export default function SortingDropdown({ className = "", sortingOptions = [] }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedSortingOptions = Object.fromEntries(searchParams.entries());

  const { order, orderBy } = sortingOptions[0] || {};

  const [paginationDetails, setPaginationDetails] = useState({
    ...defaultPage,
    orderBy: selectedSortingOptions?.orderBy || orderBy,
    order: selectedSortingOptions?.order || order,
  });

  const handleSorting = (e, option) => {
    e.preventDefault();
    setPaginationDetails((prev) => ({
      ...prev,
      page: 1,
      orderBy: option.orderBy,
      order: option.order,
    }));

    setSearchParams(
      (prev) => {
        prev.set("orderBy", option.orderBy);
        prev.set("order", option.order);
        prev.set("page", 1);

        return prev;
      },
      { replace: true }
    );
  };

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="transparent"
        id="dropdown-basic"
        className="border-0 hstack gap-1 px-0">
        <span
          className={`bg-primary-light hstack align-items-center gap-1 border border-primary rounded-pill px-3 py-2 text-color`}>
          {sortingOptions.find(
            (option) =>
              paginationDetails.orderBy === option.orderBy &&
              paginationDetails.order == option.order
          )?.label || sortingOptions[0]?.label}
          <RiSortAsc className="width-20 height-20" />
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {sortingOptions.map((option) => (
          <Dropdown.Item
            key={option.value}
            as={"p"}
            className="pointer m-0"
            onClick={(e) => {
              handleSorting(e, option);
            }}>
            {paginationDetails.orderBy === option.orderBy &&
            paginationDetails.order == option.order ? (
              <span className="d-flex align-items-center text-primary gap-10 fw-bold">
                {option.label}
                <FaCheck />
              </span>
            ) : (
              option.label
            )}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
